import { addDays, addYears, startOfYear } from 'date-fns';
import {
  AllocationStatus,
  InvoiceStatus,
  PaymentStatus,
} from 'pages/invoices/components/filters/filters.types';
import { SortDirection } from 'types/invoices';

export const DEFAULT_PARAMS_FOREIGN = {
  pageNumber: 1,
  resultSize: 10,
  own: false,
  administrative: false,
  startDate: addYears(addDays(startOfYear(new Date()), 1), -1),
  np: false,
  endDate: new Date(),
  status: PaymentStatus.ALL,
  invoiceStatus: InvoiceStatus.ALL,
  allocationStatus: AllocationStatus.ALL,
  sortProperty: 'logNumber',
  sortDirection: SortDirection.DESC,
};

export const DEFAULT_PARAMS_OWN = {
  pageNumber: 1,
  resultSize: 10,
  own: true,
  administrative: false,
  startDate: addYears(addDays(startOfYear(new Date()), 1), -1),
  np: false,
  endDate: new Date(),
  status: PaymentStatus.ALL,
  invoiceStatus: InvoiceStatus.ALL,
  allocationStatus: AllocationStatus.ALL,
  sortProperty: 'issueDate',
  sortDirection: SortDirection.DESC,
};

export const DEFAULT_PARAMS_ADMINISTRATIVE = {
  pageNumber: 1,
  resultSize: 10,
  own: true,
  administrative: true,
  startDate: addYears(addDays(startOfYear(new Date()), 1), -1),
  np: false,
  endDate: new Date(),
  status: PaymentStatus.ALL,
  invoiceStatus: InvoiceStatus.ALL,
  allocationStatus: AllocationStatus.ALL,
  sortProperty: 'issueDate',
  sortDirection: SortDirection.DESC,
};

export const DEFAULT_PARAMS_INTERNAL = {
  pageNumber: 1,
  resultSize: 10,
  own: false,
  administrative: false,
  startDate: addYears(addDays(startOfYear(new Date()), 1), -1),
  np: false,
  endDate: new Date(),
  status: PaymentStatus.ALL,
  invoiceStatus: InvoiceStatus.ALL,
  allocationStatus: AllocationStatus.ALL,
  sortProperty: 'logNumber',
  sortDirection: SortDirection.DESC,
  invoiceType: 'INTERNAL_CHARGE',
};
